
/**
 * Method to parse strings recieved from jsons, eg, replace &#39; with "
 * @param str the string to parse
 */
export function parseHTMLString(str: string): string {
	return str.replaceAll("&#39;", '"').replaceAll('&quot;', '"')
}
